import Dexie from 'dexie';

const db = new Dexie('RecallDB');

db.version(1).stores({
  decks: '++id, name, createdAt',
  cards: '++id, deckId, createdAt',
  reviews: '++id, cardId, deckId, reviewedAt',
  stats: 'date',
  settings: 'key',
});

db.version(2).stores({
  decks: '++id, name, createdAt, remoteId, dirty, updatedAt, syncedAt',
  cards: '++id, deckId, createdAt, remoteId, dirty, updatedAt, syncedAt',
  reviews: '++id, cardId, deckId, reviewedAt',
  stats: 'date',
  settings: 'key',
  syncLog: '++id, action, timestamp',
}).upgrade(tx => {
  return tx.table('decks').toCollection().modify(deck => {
    deck.remoteId = deck.remoteId || '';
    deck.dirty = deck.dirty ?? 0;
    deck.updatedAt = deck.updatedAt || deck.createdAt || new Date().toISOString();
    deck.syncedAt = deck.syncedAt || '';
  }).then(() => {
    return tx.table('cards').toCollection().modify(card => {
      card.remoteId = card.remoteId || '';
      card.remoteDeckId = card.remoteDeckId || '';
      card.dirty = card.dirty ?? 0;
      card.updatedAt = card.updatedAt || card.createdAt || new Date().toISOString();
      card.syncedAt = card.syncedAt || '';
    });
  });
});

// v3: isSystem flag on decks. System decks come from the GCSE Library and
// cannot be deleted by the user — enforced both client-side (DeckBrowser
// hides delete) and server-side (Lambda rejects DELETE on isSystem decks).
// systemDeckKey is a stable identifier (e.g. "gcse-biology") that lets us
// detect "already added" without relying on the user-visible name.
db.version(3).stores({
  decks: '++id, name, createdAt, remoteId, dirty, updatedAt, syncedAt, isSystem, systemDeckKey',
  cards: '++id, deckId, createdAt, remoteId, dirty, updatedAt, syncedAt',
  reviews: '++id, cardId, deckId, reviewedAt',
  stats: 'date',
  settings: 'key',
  syncLog: '++id, action, timestamp',
}).upgrade(tx => {
  return tx.table('decks').toCollection().modify(deck => {
    deck.isSystem = deck.isSystem ?? 0;
    deck.systemDeckKey = deck.systemDeckKey || '';
  });
});

export default db;
